import { render, staticRenderFns } from "./SellerPage.vue?vue&type=template&id=b67e8596&scoped=true&"
import script from "./SellerPage.vue?vue&type=script&lang=js&"
export * from "./SellerPage.vue?vue&type=script&lang=js&"
import style0 from "./SellerPage.vue?vue&type=style&index=0&id=b67e8596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67e8596",
  null
  
)

export default component.exports